// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__A4WW7","projectBackground":"project_projectBackground__qq1bj","projectTop":"project_projectTop__LDh2z"};